import * as fastq from "fastq";

export default class Queue {
    constructor() {
        this.queue = fastq.promise(async (job) => {
            await job();
        }, 1);
    }

    async push(job) {
        await this.queue.kill();
        await this.queue.push(job);
    }
}